import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    iconSection: {
        marginTop: '40px',
        marginBottom: '50px'
    },
    icon: {
        fontSize: 90
    },
    textSection: {
        maxWidth: '80%',
        marginBottom: '30px'
    },
    text: {
        fontSize: 33,
        lineHeight: '1.2em'
    },
    savingInfo: {
        height: 300,
        width: '80%',
        fontSize: 24,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    chartContainer: {
        position: 'absolute',
        opacity: 0,
        pointerEvents: 'none',
        width: 1000
    },
    footer: {
        marginTop: 'auto',
        marginBottom: theme.spacing(2),
        width: '100%',
        '& .MuiButton-root':{
            width: '75%',
            marginTop: theme.spacing(1)
        }
    }
}));

export default useStyles;